module.exports = __webpack_public_path__ + "static/img/bk-bg.4dc732f9.png";